import React from "react";
import Refundpolicy from "../styles/components/RefundPolicy.css";
import Navigation from "../components/Navigation/Navigation.js";
import Footer from "./Footer.js";

export default function RefundPolicy() {
  return (
    <>
      <Navigation />
      <div className="refund-container">
        <div className="refund-box">
          <h1>Refund Policy</h1>
          <p><em>Last Updated: August 2025</em></p>

          <p>
            At <strong>Flight Reservation Hub</strong>, we value your trust and 
            strive to provide the best booking experience possible. This Refund Policy 
            explains the conditions under which refunds are issued for flight bookings 
            made through our platform.
          </p>

          <h2>1. General Policy</h2>
          <p>
            All bookings are subject to airline refund policies. Flight Reservation Hub 
            acts as an intermediary platform and does not directly operate flights. 
            Refund requests must comply with the airline’s terms and conditions.
          </p>

          <h2>2. Refund Eligibility</h2>
          <ul>
            <li>Refund eligibility depends on the airline’s fare rules.</li>
            <li>Refunds may not be available for promotional or discounted tickets.</li>
            <li>Refunds are only processed for cancellations made before flight departure, 
                as per airline policies.</li>
          </ul>

          <h2>3. Cancellation Charges</h2>
          <p>
            Airlines may charge a cancellation fee, which will be deducted from your 
            refund amount. Service fees charged by Flight Reservation Hub are non-refundable.
          </p>

          <h2>4. Processing Time</h2>
          <p>
            Refunds may take <strong>7–14 business days</strong> to reflect in your bank account, 
            depending on your payment method and airline policies.
          </p>

          <h2>5. No-Show Policy</h2>
          <p>
            If a passenger fails to show up for a scheduled flight without prior cancellation, 
            refunds will not be provided unless specified by the airline.
          </p>

          <h2>6. Contact for Refunds</h2>
          <p>
            For refund requests or assistance, please contact our support team at: <br />
            <a href="mailto:support@flightreservationhub.com">
              support@flightreservationhub.com
            </a>
          </p>

        </div>
      </div>
      
      <Footer/>
    </>
  );
}
